module.controller('overlayCtrl', ['$scope', '$state', 'OVERLAY', '$window',
  function ($scope, $state, OVERLAY, $window) {
    $scope.overlay = OVERLAY[$state.current.name];

    $scope.goBack = function(){
      $window.history.back();
    };
  }]);
